export { default } from "./JeansSizeSelector";
